(function () {

  'use strict';

  angular.module('specsguardApp')
    .factory('authInterceptor', authInterceptor);

  authInterceptor.$inject = ['$q', '$cookies', '$state'];

  function authInterceptor ($q, $cookies, $state) {
    return {
      // Add authorization token to headers
      request: function (config) {
        config.headers = config.headers || {};
        if ($cookies.get('sg')) {
          config.headers.Authorization = 'Bearer ' + $cookies.get('sg');
        }
        return config;
      },

      // Intercept 401s and redirect you to login
      responseError: function (response) {
        if (response.status === 401) {
          $state.go('logout');
          return Promise.reject(response);
        }
        return $q.reject(response);
      }
    };
  }

})();

